/**
 * Created by asiulik on 20.11.2017.
 */

define(['jquery', 'lodash', 'slick', './slider/sliderPager'], function($, _, Slick, sliderPagers){

    var changeDefaultPagerViewMaxCount = 7;
    var changeDefaultPagerViewMaxCountMobile = 5;

    function Sliders(layout){ this.layoutInstance = layout; }

    Sliders.prototype.init = function(){

        var _this = this;

        var $sliders = $('.m__slider');

        this.sliders = [];

        if(!$sliders.length) return;

        [].forEach.call($sliders, function(slider) {

            var sliderInstance = new Slider(slider, _this.layoutInstance);
            sliderInstance.init();

            _this.sliders.push(sliderInstance);

        });
    };

    Sliders.prototype.getInstances = function(){
        return this.sliders;
    };

    function Slider(slider, layoutInstance){
        this.slider = slider;
        this.layoutInstance = layoutInstance;
    }

    Slider.prototype.init = function(){
        this.createSlider(this.slider);
    };

    Slider.prototype.createSlider = function(slider){

        var _this = this;
        var $slider = $(slider);

        var domSliderConfig = $slider.data('config') || {};

        this.$slider = $slider;

        var $sliderElement = $slider.find('.slider');
        var $slides = $sliderElement.find('.m__slider__item');
        var $status = $slider.find('.m__slider__status');

        this.$slides = $slides;

        var $arrowLeft = $slider.find('.slider__arrow--left');
        var $arrowRight = $slider.find('.slider__arrow--right');

        $sliderElement.on('init', function(){

        });

        // console.log('this.layoutInstance.small', this.layoutInstance.small);

        $sliderElement.on('beforeChange', function(event, slick, currentSlide, nextSlide){

            var $currentSlide = $slides.eq(currentSlide);
            var video = $currentSlide.find('video');

            if(video.get(0)){
                video.get(0).pause();
            }

        });

        $sliderElement.on('afterChange', function(event, slick, currentSlide, nextSlide){

            var $currentSlide = $slides.eq(currentSlide);
            var video = $currentSlide.find('video');
            var contentToDisplay = $currentSlide.data('displayContent');

            if(video.get(0)){
                video.get(0).play();
            }

            if(contentToDisplay) {

                var $contentToDisplay = $(contentToDisplay);

                if($contentToDisplay.length){
                    $contentToDisplay.closest('.slider__contents').find('.slider__content__dynamic')
                        .removeClass('slider__content__dynamic--visible');

                    $contentToDisplay.addClass('slider__content__dynamic--visible');
                }
            }

        });

        var slidesCount = this.$slides.length;
        
        $sliderElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {

            if($slides.length >= _this.getMaxSlidesCountToDisplayDots()) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                $status.text(i + '/' + slick.slideCount);
            }

        });

        $sliderElement.on('init', function (event, slick, currentSlide, nextSlide) {

            $sliderElement.addClass('slider__elements slider__elements--' + $slides.length);

        });

        this.$sliderReference = $sliderElement.slick(_.extend({
            arrows: true,
            dots: slidesCount < _this.getMaxSlidesCountToDisplayDots(),
            nextArrow: $arrowRight,
            prevArrow: $arrowLeft,
            customPaging: _this.getCustomPaginTemplateBuilder.bind(_this),
        }, domSliderConfig));

        this.layoutInstance.on('reload', function(){

            $status.text('');

            var config = _.extend({
                arrows: true,
                dots: slidesCount < _this.getMaxSlidesCountToDisplayDots(),
                nextArrow: $arrowRight,
                prevArrow: $arrowLeft,
                customPaging: _this.getCustomPaginTemplateBuilder.bind(_this),
            }, domSliderConfig);

            $sliderElement.slick('slickSetOption', config, true);

        })

    };

    Slider.prototype.getMaxSlidesCountToDisplayDots = function(){

        return this.layoutInstance.small ? changeDefaultPagerViewMaxCountMobile : changeDefaultPagerViewMaxCount;

    };


    Slider.prototype.getCustomPaginTemplateBuilder = function(){

        var slidesCount = this.$slides.length;

        if(slidesCount >= this.getMaxSlidesCountToDisplayDots()) {
            return sliderPagers.SliderPageNumbers.apply(this, arguments);
        }

        return sliderPagers.SliderPagerDefault.apply(this, arguments);

    };

    return Sliders;


});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/slider.js